'use client'

import { IFRAME_SEARCH_PARAM_KEYS } from '@/constants/iframe'
import { queryParametersSchema } from '@/schemas/room'
import { useParams, useSearchParams } from 'next/navigation'

export const useEnableFull3d = () => {
  const { roomId } = useParams()
  const searchParams = useSearchParams()

  const full3dParam = searchParams?.get(IFRAME_SEARCH_PARAM_KEYS.FULL3D)
  const parseResult = queryParametersSchema.safeParse({ full3d: full3dParam })
  const enableFull3d = Boolean(roomId && parseResult.success && parseResult.data.full3d)

  return enableFull3d
}
